module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "product-modal"
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("activator")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('Configure shirt')))]), _vm._v(" "), _c('div', {
    staticClass: "ui left aligned",
    attrs: {
      "slot": "toolbar"
    },
    slot: "toolbar"
  }, [_c('button', {
    staticClass: "ui button green",
    on: {
      "click": function($event) {
        return _vm.$refs.modal.close()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Validate')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Options')))]), _vm._v(" "), _c('div', {
    staticClass: "scroll cards"
  }, _vm._l((_vm.groups), function(options, index) {
    return _c('parameters-card', {
      key: index,
      class: {
        active: _vm.group_index == index
      },
      attrs: {
        "index": index,
        "options": options
      },
      model: {
        value: (_vm.group_index),
        callback: function($$v) {
          _vm.group_index = $$v
        },
        expression: "group_index"
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Parameters')))]), _vm._v(" "), _c('attribute-selector', {
    attrs: {
      "group_index": _vm.group_index
    },
    model: {
      value: (_vm.attribute_index),
      callback: function($$v) {
        _vm.attribute_index = $$v
      },
      expression: "attribute_index"
    }
  }, [_vm._v(_vm._s(_vm.group_index))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('value-selector', {
    key: _vm.group_index,
    attrs: {
      "group_index": _vm.group_index,
      "attribute_index": _vm.attribute_index
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc9e1fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/ProductModal.vue
// module id = 500
// module chunks = 1